import React from 'react';
import { motion } from 'framer-motion';
import {
  FiArrowRight,
  FiExternalLink,
  FiGithub,
  FiLinkedin,
  FiMail,
  FiMessageCircle,
} from 'react-icons/fi';

const fadeUp = {
  hidden: { opacity: 0, y: 32 },
  visible: { opacity: 1, y: 0 },
};

const iconMap = {
  LinkedIn: <FiLinkedin />,
  GitHub: <FiGithub />,
  Email: <FiMail />,
  WhatsApp: <FiMessageCircle />,
};

const contactLinksWithWhatsApp = (links, whatsappValue) => [
  ...links,
  {
    label: 'WhatsApp',
    value: whatsappValue,
    href: 'http://wa.me/5527997020791',
  },
];

const openCookiePreferences = () => {
  window.dispatchEvent(new Event('icaro-open-cookie-preferences'));
};

const Contact = ({ content, footer, legal }) => (
  <section id="contact" className="section contact-section">
    <div className="container contact-layout">
      <motion.div
        className="contact-copy"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.2 }}
        variants={fadeUp}
        transition={{ duration: 0.55 }}
      >
        <p className="eyebrow">{content.eyebrow}</p>
        <h2>{content.title}</h2>
        <p>{content.intro}</p>

        <div className="contact-cta-row">
          <a className="button button-primary" href="mailto:icaro.lanes@gmail.com">
            <FiMail />
            {content.primaryCta}
          </a>
          <a
            className="button button-secondary"
            href="https://linkedin.com/in/icarolanes"
            target="_blank"
            rel="noreferrer"
          >
            <FiExternalLink />
            {content.secondaryCta}
          </a>
        </div>
      </motion.div>

      <motion.div
        className="contact-card"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.2 }}
        variants={fadeUp}
        transition={{ duration: 0.55, delay: 0.1 }}
      >
        {contactLinksWithWhatsApp(
          content.links,
          content.eyebrow === 'Contato'
            ? 'Contato direto para projetos e implantacao'
            : 'Direct contact for projects and implementation'
        ).map((link) =>
          link.href.startsWith('mailto:') ? (
            <a
              key={link.label}
              className="contact-link"
              href={link.href}
            >
              <span className="contact-link-icon">{iconMap[link.label]}</span>
              <span>
                <strong>{link.label}</strong>
                <small>{link.value}</small>
              </span>
              <FiArrowRight />
            </a>
          ) : (
            <a
              key={link.label}
              className="contact-link"
              href={link.href}
              target="_blank"
              rel="noreferrer noopener"
            >
              <span className="contact-link-icon">{iconMap[link.label]}</span>
              <span>
                <strong>{link.label}</strong>
                <small>{link.value}</small>
              </span>
              <FiArrowRight />
            </a>
          )
        )}
      </motion.div>
    </div>

    <div className="container footer-line">
      <div className="footer-meta">
        <p>{footer?.includes('2026') ? '(c) 2026 Icaro Felipe de Lanes.' : footer}</p>
        <div className="footer-legal">
          <a href={legal.cookiesHref}>{legal.cookiesLabel}</a>
          <a href={legal.privacyHref}>{legal.privacyLabel}</a>
          <button type="button" onClick={openCookiePreferences}>
            {legal.manageLabel}
          </button>
        </div>
      </div>
    </div>
  </section>
);

export default Contact;
